import { render } from "./TheNotifications.vue?vue&type=template&id=67aef938"
import script from "./TheNotifications.vue?vue&type=script&lang=js"
export * from "./TheNotifications.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__